import { render, staticRenderFns } from "./ListBoxNewOrder.vue?vue&type=template&id=1e0105c4&scoped=true"
import script from "./ListBoxNewOrder.vue?vue&type=script&lang=js"
export * from "./ListBoxNewOrder.vue?vue&type=script&lang=js"
import style0 from "./ListBoxNewOrder.vue?vue&type=style&index=0&id=1e0105c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0105c4",
  null
  
)

export default component.exports